<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划变更单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form ref="form" inline size="mini" disabled label-width="100px" :model="conditions">
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="plan_number" class="line-16" label="销售计划编号">
              <el-input
                v-model="conditions.plan_number"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input
                v-model="conditions.plan_order"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划变更单" />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="提报类型">
              <el-select
                v-model="conditions.report_type"
                placeholder=""
              >
                <el-option v-for="item in selectDataOptions['A0001']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号">
              <el-input
                v-model="conditions.customer"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.cust_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.customer_type"
                placeholder=""
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-select
                v-model="conditions.plan_type"
                placeholder=""
              >
                <el-option v-for="item in selectDataOptions['A0002']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-select
                v-model="conditions.wlybrand"
                placeholder=""
              >
                <el-option v-for="item in selectDataOptions['A0019']" :key="item.id" :value="item.value" :label="item.name" />

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月份">
              <el-date-picker
                v-model="conditions.monat"
                type="month"
                format="MM"
                value-format="MM"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="adj_reason" label="变更原因">
              <el-select
                v-model="conditions.adj_reason"
                type="select"
                placeholder=""
              >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约审批单号" prop="approval_no">
              <el-input
                v-model="conditions.approval_no"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input
                v-model="conditions.sal_center_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input v-model="conditions.region_text" @change="getCityArea" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.city_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                v-model="conditions.sales_emp_name"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                v-model="conditions.porder_status"
                placeholder=""
              >
                <el-option v-for="item in selectDataOptions['A0025']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_comment"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="现有计划量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="总计划量(件)">
              <el-input
                v-model="conditions.total_qty"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="初始计划量(件)">
              <el-input
                v-model="conditions.initplan_qty"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已开票计划量(件)">
              <el-input
                v-model="conditions.billing_qty"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已占用计划量(件)">
              <el-input
                v-model="conditions.atp_qty"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="剩余可用计划量(件)">
              <el-input
                v-model="conditions.remain_qty"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="计划量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="curnt_adjqty"
              class="widget-view line-16"
              label="本次调整计划量(件)"
            >
              <el-input
                v-model="conditions.curnt_adjqty"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="futur_adjqty"
              class="widget-view line-16"
              label="未调整计划量(件)"
            >
              <el-input
                v-model="conditions.futur_adjqty"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="现有计划额（参考）" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16">
              <template #label>
                总计划额<br>(万元)
              </template>
              <el-input
                v-model="conditions.total_amt"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16">
              <template #label>
                初始计划额<br>(万元)
              </template>
              <el-input
                v-model="conditions.initplan_amt"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已扣减计划额(万元)">
              <el-input
                v-model="conditions.billing_amt"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已占用计划额(万元)">
              <el-input
                v-model="conditions.atp_amt"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="剩余可用计划额(万元)">
              <el-input
                v-model="conditions.remain_amt"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="计划额（参考）" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="curnt_adjamt"
              class="widget-view line-16"
              label="本次调整计划额(万元)"
            >
              <el-input
                v-model="conditions.curnt_adjamt"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="未调整计划额(万元)">
              <el-input
                v-model="conditions.futur_adjamt"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="状态变更记录"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="550"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>

  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanByNumber } from '@/api/sap/sale-plan'
import { apiSapClientFindInfo } from '@/api/common'
export default {
  data() {
    return {
      selectDataOptions: {},
      loading: false,
      conditions: {
        uname: '',
        datum: '',
        porder_status: 'E001',
        sal_center_name: '',
        plan_number: '',
        plan_order: '',
        report_type: '',
        customer: '',
        cust_name: '',
        customer_type: '',
        plan_type: '',
        wlybrand: '',
        gjahr: '',
        monat: '',
        adj_reason: '',
        sal_center: '',
        region: '',
        region_text: '',
        city_text: '',
        city: '',
        order_type: 'ZP02',
        sales_emp_name: '',
        total_qty: '',
        initplan_qty: '',
        billing_qty: '',
        atp_qty: '',
        remain_qty: '',
        total_amt: '',
        initplan_amt: '',
        billing_amt: '',
        atp_amt: '',
        remain_amt: '',
        curnt_adjqty: '',
        futur_adjqty: '',
        curnt_adjamt: '',
        futur_adjamt: '',
        remark: '',
        audit_comment: ''
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      }
    }
  },
  computed: {
  },
  created() {
    // 销售计划变更原因 字典：A0003
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0025')
    this.getSelectDictDataOrigin('A0001')
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0019')
    this.salePlanCountFindById()
  },

  methods: {
    async salePlanCountFindById() {
      const { data } = await getSalePlanByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data?.ls_head || {})
      this.initCustomer()
      this.gridOptions.data = data?.lt_chg_history || []
    },
    async initCustomer() {
      const params = {
        rt_partner: [
          {
            SIGN: 'I',
            OPTION: 'EQ',
            LOW: this.conditions.customer,
            HIGH: ''
          }
        ],
        page: 1,
        pagesize: 50
      }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      if (data.length) {
        this.conditions.sales_emp_name = data[0].sales_emp_name
        this.conditions.sales_emp = data[0].sales_emp
        this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanChangeCheck.vue